import { useMemo } from 'react';

import { useAtomValue } from 'jotai';

import appConfig from 'app-config';

import { userDataAtom } from 'src/stores/auth/atoms';
import getDeviceId from 'src/utils/device/id';

export default function useHelpCenterUrl(customTicketFormId?: string) {
  const userData = useAtomValue(userDataAtom);

  const resolvedTicketFormId = useMemo(() => {
    if (appConfig.serviceCode === 'azar' && customTicketFormId == null) {
      return '114093958053';
    }

    return customTicketFormId;
  }, [customTicketFormId]);

  return useMemo(() => {
    const url = new URL(appConfig.helpCenterBaseUrl);
    const userName = userData?.userProfile?.username;

    if (resolvedTicketFormId && userName) {
      url.pathname = '/hc/requests/new';

      url.searchParams.append('ticket_form_id', resolvedTicketFormId);
      url.searchParams.append('entry.15134161430809', getDeviceId());
      url.searchParams.append('entry.38573527', userName);
    }

    return url.toString();
  }, [userData, resolvedTicketFormId]);
}
